import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';

import PagosAdd from './PagosAdd';
import { Http } from '../../../support';
import Result from '../../../facturotopia/Result';
import ShowPagoInfo from './components/ShowPagoInfo';
import Loading from '../../../facturotopia/loading/Loading';
import TipoComprobante from '../support/enum/TipoComprobante';
import PageHeader from '../../../support/page-header/PageHeader';
import ProcessCfdiToJsonInputConversion from '../transformers/ProcessCfdiToJsonInputConversion';
import DocumentoRelacionadoImpuestosCalculator from '../support/pagos/DocumentoRelacionadoImpuestosCalculator';

class PagosManagement extends Component {

  state = {};

  constructor(props) {
    super(props);

    const { data = {}} = props.location.state || {};
    const { uuid } = this.props.match.params;

    this.state = {
      busy: true,
      uuid: uuid,
      data: !!data.uuid ? { ...data } : { uuid }
    }
  }

  componentDidMount() {
    const { uuid } = this.state.data

    this.handleOnSearch(uuid);
  }

  handleOnSearch = async (cfdiUuid) => {
    try {
      this.setState({
        busy: true
      });

      const response = await Http.get(`/api/comprobantes/${cfdiUuid}?include=emisor,receptor,input,pagos,factoraje`);

      let input = response.data.input;

      input.Emisor = response.data.emisor;
      input.Receptor = response.data.receptor;
      input.Factoraje = response.data.factoraje;

      const comprobante = TipoComprobante.pago();

      const data = ProcessCfdiToJsonInputConversion.make(input, comprobante);

      const impuestos = DocumentoRelacionadoImpuestosCalculator.make(data).apply();

      this.setState({
        input: data,
        data: {
          FechaPago: new Date(),
          HoraPago: '12:00',
          IdDocumento: this.state.uuid,
          MetodoDePagoDR: 'PPD',
          MonedaDR: data.Moneda,
          EquivalenciaDR: data.TipoCambio,
          NumParcialidad: data.Factoraje?.NumeroParcialidad,
          ImpSaldoAnt: data.Factoraje?.ImporteSaldoInsoluto,
          ImpSaldoInsoluto: data.Factoraje?.ImporteSaldoInsoluto,
          ObjetoImpDR: !!impuestos ? '02': '01',
          ImpuestosDR: impuestos
        }
      });
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No fue posible leer tu factura. =('
      });
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  render() {
    const { busy, data, input, uuid } = this.state;

    if (busy === true) {
      return <Loading />
    }

    const isPaid = data.ImpSaldoAnt <= 0;

    return (
      <div className="comprobantes-create">
        <PageHeader to={ `/app/comprobantes/${this.state.uuid}/info` } text="Mi factura" />

        { !!isPaid && <Result className="mt-5" title="Pagado" subtitle="La factura ha sido pagada en su totalidad" /> }

        <div>
          { !busy && <ShowPagoInfo uuid={ uuid } data={ input } /> }
        </div>

        { !busy && !isPaid && (
          <Row>
            <Col>
              <PagosAdd
                uuid={ uuid }
                busy={ busy }
                input={ input }
                data={ data }
              />
            </Col>
          </Row>
        )}

      </div>
    );
  }
}

export default PagosManagement;